<template>
  <div class="container">
    <ModalContainer />
    <Transition name="search">
      <SearchForm v-if="$store.getters['search/active']" />
    </Transition>
    <Drawer />
    <slot />
  </div>
</template>

<script>
import ModalContainer from '@components/modals/ModalContainer'
import Drawer from '@components/drawers/Drawer'
import SearchForm from '@components/SearchForm'

export default {
  components: { Drawer, ModalContainer, SearchForm },
  watch: {
    '$page.props.flash': {
      handler (message) {
        if (message.success) {
          this.$noty.success(message.success)
        }

        if (message.error) {
          this.$noty.error(message.error)
        }
      },
      deep: true,
    },
  },
}
</script>
